import { inspectionTemplateSource } from 'serviceWorker/services/inspectionTemplates/inspectionTemplateSource';
import { queueInspectionTemplateChanges } from 'serviceWorker/services/inspectionTemplates/queueInspectionTemplateChanges';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { inspectionTemplateContract } from 'shared/domain/inspectionTemplate/inspectionTemplateContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the template requests: reads once the templates are downloaded
 * (at once and empty for standard users), template and checklist item changes
 * once queued (their outcome follows as an event with the change's `uniqueId`).
 */
export function serveInspectionTemplateRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(inspectionTemplateContract, inspectionTemplateSource),
    channelServer.handle(inspectionTemplateContract, {
      getOneById: ({ id }) => inspectionTemplateSource.getOneById(id),
      ...queueInspectionTemplateChanges,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
